import * as React from "react";
import { cn } from "@nfp-tracker/utils";
import heartCalendarIconSrc from "../images/icon.png";

type HeartCalendarIconProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  "src"
> & {
  alt?: string;
};

const HeartCalendarIcon = React.forwardRef<
  HTMLImageElement,
  HeartCalendarIconProps
>(
  (
    {
      className,
      alt = "NFP Tracker icon",
      draggable = false,
      loading = "lazy",
      ...props
    },
    ref,
  ) => (
    <img
      ref={ref}
      src={heartCalendarIconSrc}
      alt={alt}
      className={cn("inline-block select-none", className)}
      draggable={draggable}
      loading={loading}
      {...props}
    />
  ),
);

HeartCalendarIcon.displayName = "HeartCalendarIcon";

export { HeartCalendarIcon };
